export default "__VITE_ASSET__BwNRytVE__"